import { handleActions } from 'redux-actions';
import moment from 'moment';

import sumBy from 'lodash/sumBy';

import createCalendar, { getDateRangeWithTimeZoneFromCalendar } from '../shared/calendar';
import http from '../shared/http';

export const namespace = 'quidsReport';

const calendar = createCalendar({
	namespace,
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
const APPLY = `${namespace}/apply`;
const CLEAR = `${namespace}/clear`;

// initial state
const initialState = {
	isLoading: true,
	isError: false,
	data: null,
	calendar: calendar.initialState
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			request(getRequestQuery(getState), FETCH_DATA_SUCCESS)(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	},
	apply: () => (dispatch, getState) => {
		dispatch({ type: APPLY });
		dispatch(actions.own.fetchData());
	},
	clear: () => (dispatch, getState) => {
		dispatch({ type: CLEAR });
		dispatch(actions.own.fetchData());
	},
	calendar: calendar.actions
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const months = getMonths(getDateRangeWithTimeZoneFromCalendar(state.calendar));

			const data = action.payload.data;

			const $total = {
				purchase_points: sumBy(data, 'purchase_points'),
				exchange_amount: sumBy(data, 'exchange_amount'),
				exchange_points: sumBy(data, 'exchange_points'),
				avg_accumulated: sumBy(data, 'accumulated') / sumBy(data, 'count'),
				accumulated: sumBy(data, 'accumulated')
			};

			return {
				...state,
				data: {
					list: data,
					$total,
					months
				},
				isLoading: false,
				isError: false
			};
		},
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		}),
		[APPLY]: (state, action) => ({
			...state,
			data: null,
			isLoading: true
		}),
		[CLEAR]: (state, action) => initialState
	},
	calendar.reducers
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getCalendar: state => calendar.selectors.getCalendar(
		state => state[namespace].calendar,
		state => state
	)(state)
};

function getRequestQuery(getState) {
	const state = getState()[namespace];

	const range = getDateRangeWithTimeZoneFromCalendar(state.calendar);

	return {
		dates: [range.start, range.end]
	};
}

function request(query, successActionType) {
	return http({
		url: 'v2/quids-report',
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}

function getMonths(range) {
	const start = moment(range.start).startOf('month');
	const end = moment(range.end).startOf('month');

	const n = end.diff(start, 'month');

	return Array.from({ length: n + 1 }, (_, i) => start.clone().add(i, 'month'));
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/quids-report/index.js